// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"835":"3be2d1a4","972":"8d4b1328"}[chunkId] + ".chunk.css");